import axios from 'axios';
import { from } from 'rxjs';

export const getReturnDetails = (returnId) => {
  const getAndTransform = axios.get(`/return/${returnId}`).then((response) => {
    return response.data;
  });

  const return$ = from(getAndTransform);
  return return$;
};
